<template>
  <div class="search">
    <div class="container">
      <div class="search__header">
        <Find v-model="modelValue" />
      </div>
      <div v-if="items.length == 0 && !isLoading" class="search__not-found">
        <svg class="" width="221" height="217">
          <use xlink:href="@/assets/icons/sprite.svg#notFound"></use>
        </svg>
        Пока ничего не нашли
      </div>
      <div v-if="isLoading" class="loader">
        <div class="loader-spinner"></div>
      </div>
      <div v-else class="search__list">
        <Card v-for="item in items" :data="item" />
      </div>
    </div>
  </div>
  <CartModal />
</template>
<script setup lang="ts">
  import Card from "@/components/Card.vue";
  import CartModal from "@/components/CartModal.vue";
  import Find from "@/components/Find.vue";
  import { IProduct } from "@/models/models";
  import { ref, watch } from "vue";

  const modelValue = ref<string>("" as string);

  let tm: any = null;

  const items = ref<Array<IProduct>>([] as Array<IProduct>);

  const isLoading = ref<boolean>(false as boolean);

  function onFind() {
    let localValue = modelValue.value;

    if (localValue.length > 3) {
      isLoading.value = true;
      if (tm) {
        clearTimeout(tm);
      }
      tm = setTimeout(async () => {
        fetch(`https://akshop.a-dev.xyz/api/v1/catalog/products?q=${localValue}`)
          .then((response) => response.json())
          .then((data) => {
            items.value = data.items;
            isLoading.value = false;
          });
      }, 600);
    } else {
      items.value = [];
    }
  }

  watch(
    () => modelValue.value,
    () => {
      onFind();
    }
  );
</script>
<style lang="scss">
  .search {
    &__header {
      padding-top: 12px;
    }

    &__not-found {
      margin-top: 72px;

      display: flex;
      flex-direction: column;
      gap: 10px;
      align-items: center;
      justify-content: center;

      color: $darkGray;
      font-size: 22px;
      line-height: 24px;
      font-weight: 700;
    }

    &__list {
      margin-top: 20px;
      padding-bottom: 12px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
    }
  }
</style>
